/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ word: NonNullable<unknown> }} Gdpr_Type_To_ConfirmInputs */

const cs_gdpr_type_to_confirm = /** @type {(inputs: Gdpr_Type_To_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pro potvrzení napište ${i?.word}`)
};

const en_gdpr_type_to_confirm = /** @type {(inputs: Gdpr_Type_To_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Type ${i?.word} to confirm`)
};

/**
* | output |
* | --- |
* | "Type {word} to confirm" |
*
* @param {Gdpr_Type_To_ConfirmInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_type_to_confirm = /** @type {((inputs: Gdpr_Type_To_ConfirmInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Type_To_ConfirmInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_type_to_confirm(inputs)
	return cs_gdpr_type_to_confirm(inputs)
});